export default function CommunityGuidelines() {
  return (
    <div className="min-h-screen bg-background">
      <main className="max-w-3xl mx-auto px-4 py-12 sm:py-16">
        <h1 className="text-3xl sm:text-4xl font-heading font-bold text-foreground">
          Community Guidelines
        </h1>

        <div className="mt-8 space-y-5 text-foreground/90 leading-relaxed">
          <p>Vexi works because of the community. Please follow these simple rules:</p>

          <ul className="list-disc pl-6 space-y-1 text-foreground/90">
            <li>Be accurate: Only share real prices you see in-store</li>
            <li>Be honest: No fake or misleading reports</li>
            <li>Add proof: Upload clear photos where possible</li>
            <li>No spam: Don’t post irrelevant or repeated content</li>
            <li>Be respectful: Keep it helpful for everyone</li>
          </ul>

          <p>We may remove content or restrict accounts that don’t follow these guidelines.</p>
        </div>
      </main>
    </div>
  );
}

